export default __webpack_public_path__ + "static/media/788.99d4ea23.png";